import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {BaseCustomDialog} from '../base-custom-dialog';
import {ActionIconHelper} from '../../../../helper/action-icon.helper';
import {IContact, SolveDuplicateContact} from '../../../../models/leads/leads.model';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {LEADS_DATA_SERVICE, LeadsDataService} from '../../../../services/leads/leads-data.service';
import {CONTACTS_DATA_SERVICE, ContactsDataService} from '../../../../services/contacts/contacts-data.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { Store } from '@ngxs/store';
import { HideLoader, ShowLoader } from '../../../store/loader/loader.actions';
import { ValidatorHelper } from '../../../../helper/validator.helper';

@Component({
  selector: 'fi-new-email',
  templateUrl: './new-email.component.html',
  styleUrls: ['./new-email.component.scss'],
  standalone: false,
})
export class NewEmailComponent extends BaseCustomDialog implements AfterViewInit {

  emailForm = this.fb.group({
    Id: this.fb.control(null),
    Email: this.fb.control('', [Validators.email, Validators.pattern(ValidatorHelper.emailValidator)]),
    AdditionalEmail: this.fb.control('', [Validators.email, Validators.pattern(ValidatorHelper.emailValidator)]),
  });

  contactForm: UntypedFormGroup;
  importedContact: IContact;

  contactName = '';
  leadId: number;
  title: string;
  darkIconUrl = ActionIconHelper.getActionIconUrl('NEW-EMAIL', true);
  iconUrl = ActionIconHelper.getActionIconUrl('NEW-EMAIL', false);
  hasEmailErrors = false;
  @ViewChild('emailField') emailField: ElementRef;
  emails = false;
  existingId: string;

  constructor(
    public dialogRef: MatDialogRef<NewEmailComponent>,
    private readonly router: Router,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string, contactForm: UntypedFormGroup, importedContact: IContact; existingId : string},
    @Inject(LEADS_DATA_SERVICE) private leadsDataService: LeadsDataService,
    @Inject(CONTACTS_DATA_SERVICE) private contactsDataService: ContactsDataService,
    private fb: UntypedFormBuilder,
    private store: Store,
  ) {
    super(dialogRef);

    this.contactName = dialogData?.importedContact.FirstName + " " + dialogData?.importedContact.LastName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
    this.contactForm =  dialogData?.contactForm;
    this.importedContact = dialogData?.importedContact;
    this.existingId = dialogData?.existingId
  }



  ngAfterViewInit(): void {
    this.emailField?.nativeElement.focus();
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef, 'simple-closed');
  }

  backDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  isInvalidForm(fieldName: string): boolean {
    if (!!this.emailForm?.get('AdditionalEmail').value) {
      this.emails = true;
      this.hasEmailErrors = false;
      return false;
    }

    if (fieldName === 'Email') {

      const valid = this.emailField?.nativeElement.value?.match(/\S+@\S+\.\S+/);

      if (this.emailField?.nativeElement.value) {
        if (valid) {
          if (!this.emailField?.nativeElement.value.endsWith('@temp.finstral.com')) {
            this.hasEmailErrors = false;
          } else {
            this.emailField.nativeElement.value = '';
            this.hasEmailErrors = true;
          }
        }
      }
    }

    return this.emailForm.controls[fieldName].invalid;
  }

  emailsNotFilled(): boolean {
    return !this.emailForm?.get('Email').value && !this.emailForm?.get('AdditionalEmail').value;
  }

  addEmail(): void {
    this.emails = !this.emails;
  }

  submit(): void {
    if(this.emailForm.invalid || this.emailsNotFilled() || this.isInvalidForm('Email')) {
      this.hasEmailErrors =  true;
      return;
    }

    this.contactForm.patchValue(this.importedContact);
    this.contactForm.controls.Email.setValue(this.emailForm.controls.Email.value);
    this.contactForm.controls.AdditionalEmail.setValue(this.emailForm.controls.AdditionalEmail.value);

    const contact = this.contactForm.getRawValue();

    const body = {
      Mode: 0,
      NewContact: {...contact},
      ContactsToReplace: [Number(this.existingId)],
      ExistingContact: 0,
    };

    this.solveDuplicates(body as any);
  }

  solveDuplicates(body: SolveDuplicateContact): void {
    this.store.dispatch(new ShowLoader(1000));
    this.leadsDataService.solveDuplicates(this.leadId, body).subscribe(({success, data, error}) => {
      if (success) {
        this.clearClassAndCloseDialog(this.dialogRef, 'updated-mail');
      } else if (error) {
        console.log(error);
      }
      this.store.dispatch(new HideLoader());
    });
  }
}

